// extracted by mini-css-extract-plugin
export var wasteFooter = "WasteFooter-module--wasteFooter--u4dAB";